import React from "react";
import { DPGrossEarningsFile } from "Shared/types/GrossEarnings";
import { TableRow, TableCell, Link } from "@material-ui/core";
import pretty from "Shared/pretty";
import Formatting from "Modules/DataExchange/Formatting";
import { DPPermissionGate } from "Components/DP";

const GrossEarningsTableRow = ({
  manager,
  attachment,
  originalFilename,
  status,
  createdAt,
}: DPGrossEarningsFile) => {
  const fullName = Formatting.dataExchangeFullName(
    manager.firstName || "",
    manager.lastName || ""
  );
  return (
    <TableRow>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>{fullName}</TableCell>
      <TableCell>{originalFilename}</TableCell>
      <TableCell>{pretty.titleizeWord(status)}</TableCell>
      <DPPermissionGate permissionKeys={["canViewGrossEarnings"]}>
        <TableCell>
          <Link href={attachment?.url || "#"} download>
            Download
          </Link>
        </TableCell>
      </DPPermissionGate>
    </TableRow>
  );
};

export default GrossEarningsTableRow;
